module.exports = __webpack_public_path__ + "static/img/modelDetails1.b0b567d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/modelDetails1.png
// module id = Y/Ks
// module chunks = 1